export default __webpack_public_path__ + "static/media/guava.e3fc995f.png";